import React from "react";
import { Button, Icon } from "semantic-ui-react";

import styles from "./index.module.css";
import { PickProgressActions, PickProgressData } from "../../OrderOverview/OrderOverview";
import { isBoxItemVerified } from "../../../../utils/helpers/conveyor-box";

type Props = {
  data: PickProgressData;
  actions: Omit<PickProgressActions, "onConfirmExcessPicks" | "onAutoVerifyQuantity">;
  disabled: boolean;
};

const ManualIncreaseControls = ({ data, actions, disabled }: Props) => {
  const { itemId, confirmedQuantity, adjustedPickedQuantity,verifiedQuantity } = data;
  const { onIncreaseAdjustedPick, onDecreaseAdjustedPick } = actions;

  return (
    <div className={styles["pick-controls"]}>
      <div className={styles["manual-increase"]}>
        {/* <h3>Korrigera plock</h3> */}
        <div className={styles["manual-increase__controls"]}>
          <Button
            color="blue"
            className={styles["btn"]}
            fluid
            onClick={() => onDecreaseAdjustedPick(itemId)}
            disabled={ disabled || 
              (isBoxItemVerified(data) 
                ? adjustedPickedQuantity <= 0
                : verifiedQuantity <= 0)}
          >
            <Icon name="minus"></Icon>
          </Button>
          <Button
            color="blue"
            className={styles["btn"]}
            fluid
            onClick={() => onIncreaseAdjustedPick(itemId)}
            disabled={
              disabled || (adjustedPickedQuantity === confirmedQuantity && isBoxItemVerified(data))
            }
          >
            <Icon name="plus" style={{ margin: 0 }}></Icon>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManualIncreaseControls;
